import { useEffect, useRef, type ReactNode } from "react";
import { X } from "lucide-react";

export default function SiteDialog({
  children,
  titleId,
  onClose,
  className = "",
}: {
  children: ReactNode;
  titleId: string;
  onClose: () => void;
  className?: string;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    const previouslyFocused =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;
    const priorOverflow = document.body.style.overflow;
    dialog?.showModal();
    document.body.style.overflow = "hidden";
    return () => {
      dialog?.close();
      document.body.style.overflow = priorOverflow;
      previouslyFocused?.focus({ preventScroll: true });
    };
  }, []);
  return (
    <dialog
      ref={dialogRef}
      className={`site-dialog ${className}`}
      aria-labelledby={titleId}
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="dialog-surface">
        <button
          type="button"
          className="icon-button dialog-close"
          onClick={onClose}
          aria-label="Close details"
        >
          <X size={20} />
        </button>
        {children}
      </div>
    </dialog>
  );
}
